/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'starBlack': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M510.3 64.2c-5.9 0-11.7 3.2-14.7 9.7L371.7 341.1c-2.3 5.1-6.9 8.6-12.3 9.5L79.1 395.2c-13.4 2.1-18.7 19.4-8.9 29.3l204.4 205.9c3.9 3.9 5.7 9.6 4.8 15.1l-46.1 293.1c-1.7 11.1 6.6 20 16.1 20 2.5 0 5.2-.6 7.7-2.1l250.2-139.9c2.4-1.3 5.1-2 7.7-2 2.6 0 5.2.6 7.5 1.9L774.3 953c2.5 1.3 5 2 7.5 2 9.6 0 18-9.1 16.1-20.2l-49.8-292.4c-.9-5.6.8-11.2 4.6-15.2l201.8-208.7c9.6-10 4.2-27.2-9.2-29.2l-280.9-40.8c-5.3-.8-10-4.2-12.4-9.3L524.9 73.7c-3-6.3-8.8-9.5-14.6-9.5z" _fill="#111"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/starBlack.js